module.exports = __webpack_public_path__ + "static/img/3.d0fd2f45.jpg";